import type { TDataExportValueType } from 'App/data-export/types/types'
import { almondBloom } from 'App/data-export/valueTypeRenderers/renderers/almondBloom'
import { alternaria } from 'App/data-export/valueTypeRenderers/renderers/alternaria'
import { alternariaCumulativeRolling7Days } from 'App/data-export/valueTypeRenderers/renderers/alternariaCumulativeRolling7Days'
import { beeHours } from 'App/data-export/valueTypeRenderers/renderers/beeHours'
import { chillCumulativeHoursBelow45FMAR } from 'App/data-export/valueTypeRenderers/renderers/chillCumulativeHoursBelow45FMAR'
import { chillCumulativeHoursBelow45FMAY } from 'App/data-export/valueTypeRenderers/renderers/chillCumulativeHoursBelow45FMAY'
import { chillCumulativeHoursBelow45FNOV } from 'App/data-export/valueTypeRenderers/renderers/chillCumulativeHoursBelow45FNOV'
import { chillCumulativeHoursBelow45FSEP } from 'App/data-export/valueTypeRenderers/renderers/chillCumulativeHoursBelow45FSEP'
import { chillCumulativeHoursBetween32and45FMAR } from 'App/data-export/valueTypeRenderers/renderers/chillCumulativeHoursBetween32and45FMAR'
import { chillCumulativeHoursBetween32and45FMAY } from 'App/data-export/valueTypeRenderers/renderers/chillCumulativeHoursBetween32and45FMAY'
import { chillCumulativeHoursBetween32and45FNOV } from 'App/data-export/valueTypeRenderers/renderers/chillCumulativeHoursBetween32and45FNOV'
import { chillCumulativeHoursBetween32and45FSEP } from 'App/data-export/valueTypeRenderers/renderers/chillCumulativeHoursBetween32and45FSEP'
import { chillCumulativePortionsMAR } from 'App/data-export/valueTypeRenderers/renderers/chillCumulativePortionsMAR'
import { chillCumulativePortionsMAY } from 'App/data-export/valueTypeRenderers/renderers/chillCumulativePortionsMAY'
import { chillCumulativePortionsNOV } from 'App/data-export/valueTypeRenderers/renderers/chillCumulativePortionsNOV'
import { chillCumulativePortionsSEP } from 'App/data-export/valueTypeRenderers/renderers/chillCumulativePortionsSEP'
import { chillHoursBelow45F } from 'App/data-export/valueTypeRenderers/renderers/chillHoursBelow45F'
import { chillHoursBetween32and45F } from 'App/data-export/valueTypeRenderers/renderers/chillHoursBetween32and45F'
import { chillPortions } from 'App/data-export/valueTypeRenderers/renderers/chillPortions'
import { dewPoint_ABOVE } from 'App/data-export/valueTypeRenderers/renderers/dewPoint_ABOVE'
import { dewPoint_BELOW } from 'App/data-export/valueTypeRenderers/renderers/dewPoint_BELOW'
import { dewPoint_IN } from 'App/data-export/valueTypeRenderers/renderers/dewPoint_IN'
import { evapotranspirationETc } from 'App/data-export/valueTypeRenderers/renderers/evapotranspirationETc'
import { evapotranspirationETo } from 'App/data-export/valueTypeRenderers/renderers/evapotranspirationETo'
import { evapotranspirationKc } from 'App/data-export/valueTypeRenderers/renderers/evapotranspirationKc'
import { fireBlightTRV } from 'App/data-export/valueTypeRenderers/renderers/fireBlightTRV'
import { fruitGrowth } from 'App/data-export/valueTypeRenderers/renderers/fruitGrowth'
import { fruitSize } from 'App/data-export/valueTypeRenderers/renderers/fruitSize'
import { humidity_ABOVE } from 'App/data-export/valueTypeRenderers/renderers/humidity_ABOVE'
import { humidity_BELOW } from 'App/data-export/valueTypeRenderers/renderers/humidity_BELOW'
import { humidity_IN } from 'App/data-export/valueTypeRenderers/renderers/humidity_IN'
import { insectDegreeDaysCumulativeSinceBiofix } from 'App/data-export/valueTypeRenderers/renderers/insectDegreeDaysCumulativeSinceBiofix'
import { insectTrapCatches } from 'App/data-export/valueTypeRenderers/renderers/insectTrapCatches'
import { irrigationFlowRate } from 'App/data-export/valueTypeRenderers/renderers/irrigationFlowRate'
import { irrigationPressure } from 'App/data-export/valueTypeRenderers/renderers/irrigationPressure'
import { irrigationVolumeDuration } from 'App/data-export/valueTypeRenderers/renderers/irrigationVolumeDuration'
import { leafWetnessHours } from 'App/data-export/valueTypeRenderers/renderers/leafWetnessHours'
import { precipitation } from 'App/data-export/valueTypeRenderers/renderers/precipitation'
import { signalTS5 } from 'App/data-export/valueTypeRenderers/renderers/signalTS5'
import { soilIonicContent } from 'App/data-export/valueTypeRenderers/renderers/soilIonicContent'
import { soilMoisture } from 'App/data-export/valueTypeRenderers/renderers/soilMoisture'
import { soilTemperature } from 'App/data-export/valueTypeRenderers/renderers/soilTemperature'
import { soilVwc } from 'App/data-export/valueTypeRenderers/renderers/soilVwc'
import { temperature_ABOVE } from 'App/data-export/valueTypeRenderers/renderers/temperature_ABOVE'
import { temperature_BELOW } from 'App/data-export/valueTypeRenderers/renderers/temperature_BELOW'
import { temperature_IN } from 'App/data-export/valueTypeRenderers/renderers/temperature_IN'
import { temperatureInversion_ABOVEvsBELOW } from 'App/data-export/valueTypeRenderers/renderers/temperatureInversion_ABOVEvsBELOW'
import { temperatureInversion_ABOVEvsIN } from 'App/data-export/valueTypeRenderers/renderers/temperatureInversion_ABOVEvsIN'
import { trunkDisplacement } from 'App/data-export/valueTypeRenderers/renderers/trunkDisplacement'
import { wetBulb_ABOVE } from 'App/data-export/valueTypeRenderers/renderers/wetBulb_ABOVE'
import { wetBulb_BELOW } from 'App/data-export/valueTypeRenderers/renderers/wetBulb_BELOW'
import { wetBulb_IN } from 'App/data-export/valueTypeRenderers/renderers/wetBulb_IN'
import { windDirection } from 'App/data-export/valueTypeRenderers/renderers/windDirection'
import { windSpeed } from 'App/data-export/valueTypeRenderers/renderers/windSpeed'
import type { TValueTypeRenderers } from 'App/data-export/valueTypeRenderers/TValueTypeRenderers'

export const valueTypeRenderers: { [K in TDataExportValueType]: TValueTypeRenderers[K] } = {
  almondBloom: almondBloom,
  alternaria: alternaria,
  alternariaCumulativeRolling7Days: alternariaCumulativeRolling7Days,
  beeHours: beeHours,
  chillCumulativeHoursBelow45FMAR: chillCumulativeHoursBelow45FMAR,
  chillCumulativeHoursBelow45FMAY: chillCumulativeHoursBelow45FMAY,
  chillCumulativeHoursBelow45FNOV: chillCumulativeHoursBelow45FNOV,
  chillCumulativeHoursBelow45FSEP: chillCumulativeHoursBelow45FSEP,
  chillCumulativeHoursBetween32and45FMAR: chillCumulativeHoursBetween32and45FMAR,
  chillCumulativeHoursBetween32and45FMAY: chillCumulativeHoursBetween32and45FMAY,
  chillCumulativeHoursBetween32and45FNOV: chillCumulativeHoursBetween32and45FNOV,
  chillCumulativeHoursBetween32and45FSEP: chillCumulativeHoursBetween32and45FSEP,
  chillCumulativePortionsMAR: chillCumulativePortionsMAR,
  chillCumulativePortionsMAY: chillCumulativePortionsMAY,
  chillCumulativePortionsNOV: chillCumulativePortionsNOV,
  chillCumulativePortionsSEP: chillCumulativePortionsSEP,
  chillHoursBelow45F: chillHoursBelow45F,
  chillHoursBetween32and45F: chillHoursBetween32and45F,
  chillPortions: chillPortions,
  dewPoint_ABOVE: dewPoint_ABOVE,
  dewPoint_BELOW: dewPoint_BELOW,
  dewPoint_IN: dewPoint_IN,
  evapotranspirationETc: evapotranspirationETc,
  evapotranspirationETo: evapotranspirationETo,
  evapotranspirationKc: evapotranspirationKc,
  fireBlightTRV: fireBlightTRV,
  fruitGrowth: fruitGrowth,
  fruitSize: fruitSize,
  humidity_ABOVE: humidity_ABOVE,
  humidity_BELOW: humidity_BELOW,
  humidity_IN: humidity_IN,
  insectDegreeDaysCumulativeSinceBiofix_1: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_2: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_3: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_4: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_6: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_7: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_8: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_9: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_10: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_11: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_12: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_13: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_14: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_15: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_16: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_17: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_18: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_19: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_20: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_23: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_24: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_25: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_26: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_27: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_28: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_29: insectDegreeDaysCumulativeSinceBiofix,
  insectDegreeDaysCumulativeSinceBiofix_30: insectDegreeDaysCumulativeSinceBiofix,
  insectTrapCatches_1: insectTrapCatches,
  insectTrapCatches_2: insectTrapCatches,
  insectTrapCatches_6: insectTrapCatches,
  insectTrapCatches_7: insectTrapCatches,
  insectTrapCatches_9: insectTrapCatches,
  insectTrapCatches_10: insectTrapCatches,
  insectTrapCatches_11: insectTrapCatches,
  insectTrapCatches_12: insectTrapCatches,
  insectTrapCatches_15: insectTrapCatches,
  insectTrapCatches_16: insectTrapCatches,
  insectTrapCatches_17: insectTrapCatches,
  insectTrapCatches_19: insectTrapCatches,
  insectTrapCatches_20: insectTrapCatches,
  insectTrapCatches_25: insectTrapCatches,
  insectTrapCatches_27: insectTrapCatches,
  insectTrapCatches_28: insectTrapCatches,
  insectTrapCatches_29: insectTrapCatches,
  insectTrapCatches_30: insectTrapCatches,
  irrigationFlowRate: irrigationFlowRate,
  irrigationPlannedVolumeDurationSemios_emitterBuriedDrip1: irrigationVolumeDuration,
  irrigationPlannedVolumeDurationSemios_emitterBuriedDrip2: irrigationVolumeDuration,
  irrigationPlannedVolumeDurationSemios_emitterDrip1: irrigationVolumeDuration,
  irrigationPlannedVolumeDurationSemios_emitterDrip2: irrigationVolumeDuration,
  irrigationPlannedVolumeDurationSemios_emitterFloodFurrow: irrigationVolumeDuration,
  irrigationPlannedVolumeDurationSemios_emitterMicrospray: irrigationVolumeDuration,
  irrigationPlannedVolumeDurationSemios_emitterOther: irrigationVolumeDuration,
  irrigationPlannedVolumeDurationSemios_emitterOverheadCoolingMicrospray: irrigationVolumeDuration,
  irrigationPlannedVolumeDurationSemios_emitterOverheadCoolingSprinkler: irrigationVolumeDuration,
  irrigationPlannedVolumeDurationSemios_emitterSprinkler: irrigationVolumeDuration,
  irrigationPlannedVolumeDurationSemios_postFilter: irrigationVolumeDuration,
  irrigationPlannedVolumeDurationSemios_preFilter: irrigationVolumeDuration,
  irrigationPlannedVolumeDurationSemios_pump: irrigationVolumeDuration,
  irrigationPlannedVolumeDurationSemios_systemPressure: irrigationVolumeDuration,
  irrigationPressureSemios_emitterBuriedDrip1: irrigationPressure,
  irrigationPressureSemios_emitterBuriedDrip2: irrigationPressure,
  irrigationPressureSemios_emitterDrip1: irrigationPressure,
  irrigationPressureSemios_emitterDrip2: irrigationPressure,
  irrigationPressureSemios_emitterFloodFurrow: irrigationPressure,
  irrigationPressureSemios_emitterMicrospray: irrigationPressure,
  irrigationPressureSemios_emitterOther: irrigationPressure,
  irrigationPressureSemios_emitterOverheadCoolingMicrospray: irrigationPressure,
  irrigationPressureSemios_emitterOverheadCoolingSprinkler: irrigationPressure,
  irrigationPressureSemios_emitterSprinkler: irrigationPressure,
  irrigationPressureSemios_postFilter: irrigationPressure,
  irrigationPressureSemios_preFilter: irrigationPressure,
  irrigationPressureSemios_pump: irrigationPressure,
  irrigationPressureSemios_systemPressure: irrigationPressure,
  irrigationVolumeDurationSemios_emitterBuriedDrip1: irrigationVolumeDuration,
  irrigationVolumeDurationSemios_emitterBuriedDrip2: irrigationVolumeDuration,
  irrigationVolumeDurationSemios_emitterDrip1: irrigationVolumeDuration,
  irrigationVolumeDurationSemios_emitterDrip2: irrigationVolumeDuration,
  irrigationVolumeDurationSemios_emitterFloodFurrow: irrigationVolumeDuration,
  irrigationVolumeDurationSemios_emitterMicrospray: irrigationVolumeDuration,
  irrigationVolumeDurationSemios_emitterOther: irrigationVolumeDuration,
  irrigationVolumeDurationSemios_emitterOverheadCoolingMicrospray: irrigationVolumeDuration,
  irrigationVolumeDurationSemios_emitterOverheadCoolingSprinkler: irrigationVolumeDuration,
  irrigationVolumeDurationSemios_emitterSprinkler: irrigationVolumeDuration,
  irrigationVolumeDurationSemios_postFilter: irrigationVolumeDuration,
  irrigationVolumeDurationSemios_preFilter: irrigationVolumeDuration,
  irrigationVolumeDurationSemios_pump: irrigationVolumeDuration,
  irrigationVolumeDurationSemios_systemPressure: irrigationVolumeDuration,
  leafWetnessHours: leafWetnessHours,
  precipitation: precipitation,
  signalTS5: signalTS5,
  soilIonicContent: soilIonicContent,
  soilMoisture: soilMoisture,
  soilTemperature: soilTemperature,
  soilVwc: soilVwc,
  temperature_ABOVE: temperature_ABOVE,
  temperature_BELOW: temperature_BELOW,
  temperature_IN: temperature_IN,
  temperatureInversion_ABOVEvsBELOW: temperatureInversion_ABOVEvsBELOW,
  temperatureInversion_ABOVEvsIN: temperatureInversion_ABOVEvsIN,
  trunkDisplacement: trunkDisplacement,
  wetBulb_ABOVE: wetBulb_ABOVE,
  wetBulb_BELOW: wetBulb_BELOW,
  wetBulb_IN: wetBulb_IN,
  windDirection: windDirection,
  windSpeed: windSpeed,
}
